const Menu = () => {
  const menuOpener = document.querySelector('.header__nav-opener');
  const pageContainer = document.querySelector(".page");
  const backdrop = document.querySelector(".page__backdrop");
  const menuCloser = document.querySelector(".menu__close-btn");

  if (menuOpener && pageContainer && backdrop) {
    menuOpener.addEventListener("click", () => {
      if(pageContainer.classList.contains("show-menu")) {
        pageContainer.classList.remove("show-menu");
      } else {
        pageContainer.classList.add("show-menu");

        if (pageContainer.classList.contains("show-search")) {
          pageContainer.classList.remove("show-search");
        }
      }
    });
  
    backdrop.addEventListener("click", () => {
      pageContainer.classList.remove("show-menu");
    })

    document.addEventListener("keydown", (e) => {
      if (e.code == "Escape") {
        pageContainer.classList.remove("show-menu");
      }
    });
  }

  if (menuCloser) {
    menuCloser.addEventListener("click", () => {
      pageContainer.classList.remove("show-menu");
    });
  }
}

export default Menu;